import OwnerModel from '../owner/owner-model';

export default class ProducttypeModel {
    id: number;
    name: string;
    description: string;
    status: string;
    owner: any;
    ownerCaption: string;
    type: string;
    typeCaption: string;

    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        let owner = datarow.owner?.data? new OwnerModel(datarow.owner?.data) : datarow.owner;
        this.owner = owner?.id;
        this.ownerCaption = owner?.name;
        this.type = datarow.type || 'goods';
        this.typeCaption = ProducttypeModel.optionType.filter((d: any) => d.name === this.type)?.[0]?.caption || 'Goods';
        
    } 

    public static endPoint: string = 'product-types' 
    public static endPointFilter = (type?: string) => {
        return ('?populate=*&sort=name' + (type? '&filters[type]=' +type : ''));
    }
    public static url: string = '/producttype';
    public static caption: string = 'Product Type';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'active',
        owner: +OwnerModel.getOwner(),
        ownerCaption: OwnerModel.getOwnerCaption(),         
        type: 'goods',
        typeCaption: 'Goods',
        
        }
    }
    
    public static validations = [
        { name: 'name', required: true, minLength: 3 },
        { name: 'description', minLength: 3 },
    ]

    public static columns = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
        { name: 'status', caption: ' ', type: 'state', default: 'active' },
    ]

    public static columnPicklist = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
    
    public static optionType = [
        { name: 'goods', caption: 'Goods', description: 'terjual' },
        { name: 'services', caption: 'Services', description: 'digunakan' },
        { name: 'events', caption: 'Events', description: 'diikuti' },
    ]
}